import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "../seo";
import { api, articleImage } from "../api";
import { Reveal, Chapter } from "../components/motion";

export default function Education() {
    const [articles, setArticles] = useState([]);
    const [categories, setCategories] = useState([]);
    const [active, setActive] = useState("All");

    useEffect(() => {
        api.get("/articles").then((r) => {
            setArticles(r.data.articles);
            setCategories(["All", ...r.data.categories]);
        }).catch(() => {});
    }, []);

    const filtered = active === "All" ? articles : articles.filter((a) => a.category === active);

    return (
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-10 lg:py-20">
            <Seo title="Patient Education | Urology Articles by Dr. Krishnakanth AVB"
                description="Evidence-based, plain-language articles on kidney stones, urinary symptoms, prostate health, urethral stricture and more — written for patients, not for alarm." />
            <Chapter index={1} label="Patient Education" />
            <Reveal>
                <h1 className="mt-8 max-w-2xl font-display text-4xl font-medium leading-tight text-navy sm:text-5xl">
                    Understand your health in plain language
                </h1>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-steel md:text-lg">
                    Evidence-based articles written for patients. No fear-based headlines, no exaggerated claims —
                    just clear explanations grounded in established urology guidelines.
                </p>
            </Reveal>

            <Reveal delay={0.1}>
                <div className="mt-12 flex flex-wrap gap-2" data-testid="category-filters">
                    {categories.map((c) => (
                        <button key={c} onClick={() => setActive(c)}
                            data-testid={`filter-${c.toLowerCase().replace(/[\s']/g, "-")}`}
                            className={`rounded-full border px-4 py-2 text-xs font-semibold transition-all duration-200 ${
                                active === c ? "border-navy bg-navy text-white" : "border-border text-steel hover:border-navy hover:text-navy"}`}>
                            {c}
                        </button>
                    ))}
                </div>
            </Reveal>

            <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                {filtered.map((a, i) => (
                    <Reveal key={a.slug} delay={Math.min(i * 0.06, 0.3)}>
                        <Link to={`/patient-education/${a.slug}`} data-testid={`article-card-${a.slug}`}
                            className="group block h-full overflow-hidden rounded-2xl border border-border bg-white transition-all duration-300 hover:border-accent/40 hover:shadow-md">
                            <div className="h-48 overflow-hidden bg-mist">
                                <img src={articleImage(a)} alt="" loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                            </div>
                            <div className="p-7">
                                <p className="font-mono-label text-[0.6rem] text-steel">
                                    {a.category} · {a.date} · {a.reading_time} min read
                                </p>
                                <h2 className="mt-3 font-display text-xl font-medium leading-snug text-navy group-hover:text-accent transition-colors">
                                    {a.title}
                                </h2>
                                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-steel">{a.summary}</p>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
            {filtered.length === 0 && (
                <p className="mt-16 text-center text-steel" data-testid="no-articles-message">No articles in this category yet.</p>
            )}
        </div>
    );
}
